import { useOrganisationsContext } from 'contexts';

export const useOrganisations = () => {
  const { organisations } = useOrganisationsContext();
  return organisations;
};
